import React, { useEffect } from "react";
import moment from "moment";
import { AnyPeriod, castPeriod, isValidPeriod, toGQLPeriod, useIsMounted } from "@ct-react/core";
import { RangePickerController, useDefaultCalendarBlock } from "@ct-react/calendar";
import { usePickerLabelize } from "../../../../hooks/calendar";
import "./selectors.scss";

type Props = {
  mobile: boolean;
  value?: { period: AnyPeriod },
  onChange?: (value?: { period: AnyPeriod }) => void
}

const SearchItemSelectorPeriod = (
  {
    mobile,
    value,
    onChange = () => void 0
  }: Props) => {

  const isMounted = useIsMounted();
  const calendarLabelize = usePickerLabelize();
  const {
    range: [ pickerRange, setPickerRange ],
    focus: [ pickerFocus, setPickerFocus ]
  } = useDefaultCalendarBlock(!!value?.period ? castPeriod(value.period) : undefined);

  useEffect(() => {
    if (!isMounted) return;
    setPickerRange(!!value?.period ? castPeriod(value.period) : {});
  }, [ value ]);

  useEffect(() => {
    (isValidPeriod(pickerRange) && !pickerFocus) && onChange({ period: toGQLPeriod(pickerRange) })
  }, [ pickerFocus ]);

  return (
    <div className="picker">
      <RangePickerController selectedRange={pickerRange}
                             pickFocus={pickerFocus}
                             onSelectedRangeChange={setPickerRange}
                             onPickFocusChange={setPickerFocus}
                             labelize={calendarLabelize}
                             numberOfMonths={mobile ? 1 : 2}
                             firstDayOfWeek={1}
                             minDate={moment()}
                             maxDate={moment().add(1, "years")} />
    </div>);

}

export default SearchItemSelectorPeriod;
